import React from 'react';
import {
  DeprecatedModal,
  ModalCancelButton,
  ModalConfirmationButton,
  ModalText,
  ModalTitle,
} from '../../common/DeprecatedModal';

interface IProps {
  toggleModal: () => void;
  deleteTemplate: () => void;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const ConfirmationModal = (props: IProps) => {
  const title = <ModalTitle>Are you sure you want to delete this template?</ModalTitle>;
  const content = (
    <>
      <ModalText>
        By clicking "Delete Template", you will lose all of your work. Anyone with access to this template will no
        longer be able to view it.
      </ModalText>
      <ModalText> Would you still like to continue? </ModalText>
    </>
  );
  const actionButtons = (
    <>
      <ModalCancelButton onClick={props.toggleModal} aria-label="Cancel">
        Cancel
      </ModalCancelButton>
      <ModalConfirmationButton onClick={props.deleteTemplate} aria-label="delete template">
        Delete Template
      </ModalConfirmationButton>
    </>
  );
  return <DeprecatedModal {...props} title={title} content={content} actionButtons={actionButtons} />;
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default ConfirmationModal;
